import { GET_REGIONALS_DATA } from "./actionTypes";

export const getRegionalsData = (regionalsData) => {
  return {
    type: GET_REGIONALS_DATA,
    payload: regionalsData,
  };
};
